import Chart from "chart.js/auto";
import "chartjs-adapter-moment";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import printerImg from "../../images/print.gif";
import printerTwo from "../../images/printer.png";
import SevenSegmentDisplay from "../SevenSegmentStyle/SevenSegmentDisplay";
import SevenSegmentTimeDisplay from "../SevenSegmentStyle/SevenSegmentTimeDisplay";
import './Printer.css';
import NavigationButtons from "../NavigationButtons/NavigationButtons";
import { useNavigate } from 'react-router-dom';
import LiveVideo from "../LiveStream/LiveStream";


const ThreeDPrinterUnit = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("design");
  const [showLiveVideo, setShowLiveVideo] = useState(false);
  const [bgColor, setBgColor] = useState(""); // Default background color
  const [printerData, setPrinterData] = useState({
    Filament_Required: "0.00",
    Bed_Temperature: "0.00",
    Tool0_Temperature: "0.00",
    Tool1_Temperature: "0.00",
    Print_Progress: "0",
    Printer_Status: "........",
    Total_Print_Time: "0",
    Time_Elapsed: "0",
    Time_Left: "0",
    Extruder_0_Filament_Run_Out: "0",
    Extruder_1_Filament_Run_Out: "0",
  });
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [startTime, setStartTime] = useState("08:00");
  const [endTime, setEndTime] = useState("17:00");

  const chartRef = useRef(null);
  const chartInstance = useRef(null);


  const handleWatchLive = () => {
    setShowLiveVideo(true);
};


  useEffect(() => {
    const fetchData = () => {
      fetch("https://cmti-edge.online/foundry/php/smartfoundry.php")
        .then((response) => response.json())
        .then((data) => {
          setPrinterData(data);
        })
        .catch((error) => console.error("Error fetching data:", error));
    };

    fetchData();
    const interval = setInterval(fetchData, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    updateGraph();
  }, [selectedDate, startTime, endTime]);

  const showTab = (tabId) => {
    setActiveTab(tabId);
    switch (tabId) {
      case "design":
        setBgColor("#212529");
        break;
      case "parameters":
        setBgColor("#081c15");
        break;
      case "temperature":
        setBgColor("");
        break;
      default:
        setBgColor("#0d1b2a");
    }
  };

  const convertToTimeFormat = (hours) => {
    const totalSeconds = Math.floor(hours * 3600);
    const hoursPart = Math.floor(totalSeconds / 3600);
    const minutesPart = Math.floor((totalSeconds % 3600) / 60);
    const secondsPart = totalSeconds % 60;

    const formattedHours = String(hoursPart).padStart(2, "0");
    const formattedMinutes = String(minutesPart).padStart(2, "0");
    const formattedSeconds = String(secondsPart).padStart(2, "0");

    return `${formattedHours}H:${formattedMinutes}m:${formattedSeconds}s`;
  };

  const updateGraph = () => {
    fetch(
      `https://cmti-edge.online/foundry/php/tempgraph.php?date=${selectedDate}`
    )
      .then((response) => response.json())
      .then((data) => {
        const labels = [];
        const Bed_TemperatureData = [];
        const Tool0_TemperatureData = [];
        const Tool1_TemperatureData = [];

        for (let minute = 0; minute < 24 * 60; minute++) {
          const time = moment(
            `${selectedDate}T00:00:00`,
            "YYYY-MM-DDTHH:mm:ss"
          ).add(minute, "minutes");

          if (
            time.isBetween(
              `${selectedDate}T${startTime}`,
              `${selectedDate}T${endTime}`,
              null,
              "[]"
            )
          ) {
            const dataObject = data.find((obj) => {
              const createdTime = moment(obj.created_at, "YYYY-MM-DD HH:mm:ss");
              const timeDifference = Math.abs(
                time.diff(createdTime, "minutes")
              );
              return timeDifference < 1;
            });

            Bed_TemperatureData.push(
              dataObject ? parseFloat(dataObject.Bed_Temperature) : 0
            );
            Tool0_TemperatureData.push(
              dataObject ? parseFloat(dataObject.Tool0_Temperature) : 0
            );
            Tool1_TemperatureData.push(
              dataObject ? parseFloat(dataObject.Tool1_Temperature) : 0
            );
            labels.push(time.toISOString());
          }
        }

        updateChart(
          labels,
          Bed_TemperatureData,
          Tool0_TemperatureData,
          Tool1_TemperatureData
        );
      })
      .catch((error) => console.error("Error fetching graph data:", error));
  };

  const updateChart = (
    labels,
    Bed_TemperatureData,
    Tool0_TemperatureData,
    Tool1_TemperatureData
  ) => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = chartRef.current.getContext("2d");
    chartInstance.current = new Chart(ctx, {
      type: "line",
      data: {
        labels: labels,
        datasets: [
          {
            label: "Bed_Temperature",
            data: Bed_TemperatureData,
            borderColor: "yellow",
            borderWidth: 2,
            fill: false,
          },
          {
            label: "Tool0_Temperature",
            data: Tool0_TemperatureData,
            borderColor: "rgba(255, 99, 132, 1)",
            borderWidth: 2,
            fill: false,
          },
          {
            label: "Tool1_Temperature",
            data: Tool1_TemperatureData,
            borderColor: "#33F5FF",
            borderWidth: 2,
            fill: false,
          },
        ],
      },
      options: {
        scales: {
          x: {
            type: "time",
            time: {
              unit: "minute",
              minUnit: "minute",
              displayFormats: {
                minute: "HH:mm",
              },
              unitStepSize: 30,
            },
            title: {
              display: true,
              text: "Time",
              color: "white",
            },
            ticks: {
              color: "orange",
              stepSize: 30,
              callback: function (value) {
                return moment(value).format("HH:mm");
              },
            },
          },
          y: {
            title: {
              display: true,
              text: "Temperature (°C)",
              color: "white",
            },
            ticks: {
              beginAtZero: true,
              color: "orange",
              suggestedMax: 100,
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || "";
                if (label) {
                  label += ": ";
                }
                label += context.parsed.y.toFixed(2);
                return label;
              },
            },
          },
        },
        color: "white",
      },
    });
  };




  return (
    <div className="relative min-h-screen pb-16">
      <div className="flex-grow" style={{ backgroundColor: bgColor, transition: "background-color 0.5s ease" }} >
        <div className="header">3D PRINTER UNIT</div>
        <div className="flex flex-col lg:flex-row bg-gray-200">
          <div className="bg-gray-200 flex justify-center items-center w-full">
            <NavigationButtons />
          </div>
          <div className="actives_buttons flex flex-wrap  bg-gray-200 p-4 justify-center lg:justify-end gap-4">
            <button
              className="btns transparent"
              onClick={() => showTab("design")}
            >
              3D PRINTER
            </button>
            <button
              className="btns transparent"
              onClick={() => showTab("parameters")}
            >
              PROCESS PARAMETERS
            </button>
            <button
              className="btns transparent"
              onClick={() => showTab("temperature")}
            >
              TEMPERATURE
            </button>
          </div>
        </div>

        {activeTab === "design" && (
        <div id="design" className="tab-content active p-4">
          <div className="flex flex-col lg:flex-row gap-8 items-center">
            <div className="flex flex-col items-center lg:w-1/2 animate-fade-in">
              
                <div className="rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition duration-300 ease-in-out">
                  <img src={printerTwo} alt="3D Printer GIF" className="w-full" />
                </div>
              
              <h2 className="text-2xl font-bold mt-4 text-white">Front View of 3D Printer</h2>
            </div>

            <div className="flex flex-col items-center lg:w-1/2 animate-fade-in">
              {!showLiveVideo && (
                <div className="rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition duration-300 ease-in-out">
                  <img src={printerImg} alt="3D Printer GIF" className="w-full" />
                </div>
              )}
              {showLiveVideo ? (
                <LiveVideo /> // Show the LiveVideo component when "Watch Live" is clicked
              ) : (
                <button
                  onClick={handleWatchLive}
                  className="bg-red-600 hover:bg-red-700 text-white font-bold mt-8 py-2 px-4 rounded-full transition duration-300 ease-in-out transform hover:scale-105"
                >
                  Watch Live
                </button>
              )}
            </div>
          </div>
        </div>
      )}

        {activeTab === "parameters" && (
          <div id="parameters" className="tab-content">
            <div className="grid gap-4 sm:gap-6 md:gap-8 lg:gap-10 xl:gap-12 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 px-2 sm:px-4 md:px-6 lg:px-8 xl:px-10 pt-4 sm:pt-6 md:pt-8 lg:pt-10">
              {/* Parameter: Filament Required */}
              <div className="flex flex-col items-center bg-gray-700 p-3 sm:p-4 md:p-5 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-200 ease-in-out mb-4 sm:mb-5">
                <h2 className="text-base sm:text-lg md:text-xl font-bold py-2 md:py-3 lg:py-4 text-white">Filament Required (m)</h2>
                <SevenSegmentDisplay value={printerData.Filament_Required} className="w-full max-w-xs py-2 md:py-3 lg:py-4 px-2 md:px-3 lg:px-4" />
              </div>

              {/* Parameter: Extruder 0 Filament Run Out */}
              <div className="flex flex-col items-center bg-gray-700 p-3 sm:p-4 md:p-5 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-200 ease-in-out mb-4 sm:mb-5">
                <h2 className="text-base sm:text-lg md:text-xl font-bold py-2 md:py-3 lg:py-4 text-white">Extruder 0 Filament Run Out</h2>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={printerData.Extruder_0_Filament_Run_Out === "1"}
                    readOnly
                  />
                  <span className="slider round"></span>
                </label>
              </div>

              {/* Parameter: Extruder 1 Filament Run Out */}
              <div className="flex flex-col items-center bg-gray-700 p-3 sm:p-4 md:p-5 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-200 ease-in-out mb-4 sm:mb-5">
                <h2 className="text-base sm:text-lg md:text-xl font-bold py-2 md:py-3 lg:py-4 text-white">Extruder 1 Filament Run Out</h2>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={printerData.Extruder_1_Filament_Run_Out === "1"}
                    readOnly
                  />
                  <span className="slider round"></span>
                </label>
              </div>

              {/* Parameter: Print Progress */}
              <div className="flex flex-col items-center bg-gray-700 p-3 sm:p-4 md:p-5 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-200 ease-in-out mb-4 sm:mb-5">
                <h2 className="text-base sm:text-lg md:text-xl font-bold py-2 md:py-3 lg:py-4 text-white">Print Progress (%)</h2>
                <div className="progress-container">
                  <SevenSegmentDisplay value={printerData.Print_Progress} className="w-full max-w-xs py-2 md:py-3 lg:py-4 px-2 md:px-3 lg:px-4" />
                </div>
              </div>

              {/* Parameter: Printer Status */}
              <div className="flex flex-col items-center bg-gray-700 p-3 sm:p-4 md:p-5 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-200 ease-in-out mb-4 sm:mb-5">
                <h2 className="text-base sm:text-lg md:text-xl font-bold py-2 md:py-3 lg:py-4 text-white">Printer Status</h2>
                <p className="text-xl sm:text-2xl md:text-3xl text-yellow-500">{printerData.Printer_Status}</p>
              </div>

              {/* Parameter: Estimated Print Time */}
              <div className="flex flex-col items-center bg-gray-700  p-3 sm:p-4 md:p-5 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-200 ease-in-out mb-4 sm:mb-5">
                <h2 className="text-base sm:text-lg md:text-xl font-bold py-2 md:py-3 lg:py-4 text-white">Estimated Print Time</h2>
                <SevenSegmentTimeDisplay time={convertToTimeFormat(parseFloat(printerData.Total_Print_Time))} className="w-full max-w-xs py-2 md:py-3 lg:py-4 px-2 md:px-3 lg:px-4" />
              </div>

              {/* Parameter: Time Elapsed Since Printing */}
              <div className="flex flex-col items-center bg-gray-700  p-3 sm:p-4 md:p-5 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-200 ease-in-out mb-4 sm:mb-5">
                <h2 className="text-base sm:text-lg md:text-xl font-bold py-2 md:py-3 lg:py-4 text-white">Time Elapsed Since Printing</h2>
                <SevenSegmentTimeDisplay time={convertToTimeFormat(parseFloat(printerData.Time_Elapsed))} className="w-full max-w-xs py-2 md:py-3 lg:py-4 px-2 md:px-3 lg:px-4" />
              </div>

              {/* Parameter: Print Time Left */}
              <div className="print_time flex flex-col items-center bg-gray-700  p-3 sm:p-4 md:p-5 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-200 ease-in-out mb-4 sm:mb-5">
                <h2 className="text-base sm:text-lg md:text-xl font-bold py-2 md:py-3 lg:py-4 text-white">Print Time Left</h2>
                <SevenSegmentTimeDisplay time={convertToTimeFormat(parseFloat(printerData.Time_Left))} className="w-full max-w-xs py-2 md:py-3 lg:py-4 px-2 md:px-3 lg:px-4" />
              </div>
            </div>
          </div>
        )}


        {activeTab === "temperature" && (
          <div id="temperature" className="tab-content">
            <div className="row">
              <h2 style={{ marginBottom: "20px", color: "orange" }}>
                Temperature Sensor Values
              </h2>
            </div>
            <div className="parameter-row flex flex-col lg:flex-row w-full justify-around items-center mb-5  ">
              <div className=" flex flex-col items-center bg-gray-700 p-5 w-80 md:w-96 lg:w-96 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-200 ease-in-out mb-5 lg:mb-0">
                <h2 className="text-xl font-bold py-4 text-white">Bed Temperature (°C)</h2>
                <div className="led-container w-full">
                  <SevenSegmentDisplay value={printerData.Bed_Temperature} className="w-full py-4 " />
                </div>
              </div>
              <div className=" flex flex-col items-center bg-gray-700 p-5 w-80 md:w-96 lg:w-96 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-200 ease-in-out mb-5 lg:mb-0">
                <h2 className="text-xl font-bold py-4 text-white">Tool 0 Temperature (°C)</h2>
                <div className="led-container w-full">
                  <SevenSegmentDisplay value={printerData.Tool0_Temperature } className="w-full py-4 " />
                </div>
              </div>
              <div className=" flex flex-col items-center bg-gray-700 p-5 w-80 md:w-96 lg:w-96 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-200 ease-in-out mb-5 lg:mb-0">
                <h2 className="text-xl font-bold py-4 text-white">Tool 1 Temperature (°C)</h2>
                <div className="led-container w-full">
                  <SevenSegmentDisplay value={printerData.Tool1_Temperature} className="w-full py-4" />
                </div>
              </div>
            </div>

            <div className="row">
              <h2
                style={{
                  marginBottom: "20px",
                  marginTop: "20px",
                  color: "orange",
                }}
              >
                Temperature Graph
              </h2>
            </div>
            <div className="flex flex-wrap justify-center items-center">
              <div className="w-full sm:w-auto sm:flex-1 max-w-xs px-4">
                <div className="bg-gray-700 shadow-md rounded-2xl px-8 pt-6 pb-8 mb-4">
                  <label htmlFor="datePicker" className="block text-white font-bold mb-2">
                    Select Date:
                  </label>
                  <input
                    type="date"
                    id="datePicker"
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                  />
                </div>
              </div>

              <div className="w-full sm:w-auto sm:flex-1 max-w-xs px-4">
                <div className="bg-gray-700 shadow-md rounded-2xl px-8 pt-6 pb-8 mb-4">
                  <label htmlFor="startTime" className="block text-white font-bold mb-2">
                    Select Start Time:
                  </label>
                  <input
                    type="time"
                    id="startTime"
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                  />
                </div>
              </div>

              <div className="w-full sm:w-auto sm:flex-1 max-w-xs px-4">
                <div className="bg-gray-700 shadow-md rounded-2xl px-8 pt-6 pb-8 mb-4">
                  <label htmlFor="endTime" className="block text-white  font-bold mb-2">
                    Select End Time:
                  </label>
                  <input
                    type="time"
                    id="endTime"
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                  />
                </div>
              </div>

              <div className="w-full sm:w-auto sm:flex-1 max-w-xs px-4">
                <div className="bg-gray-700 shadow-md rounded-2xl px-8 pt-6 pb-8 mb-4">
                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline"
                    onClick={updateGraph}
                  >
                    Update Graph
                  </button>
                </div>
              </div>
            </div>
            <canvas ref={chartRef} width="600" height="200"></canvas>
          </div>
        )}
        <div className=" flex items-center justify-center text-center bg-[#141622] text-white w-full h-[150px] text-sm sm:text-base md:text-lg lg:text-xl">
          <p>
            Central Manufacturing Technology Institute, Tumkur Road,
            Bengaluru-560022, Karnataka, India © 2024 CMTI All rights reserved. ||
            <a href="https://example.com" className="mx-2 hover:underline">
              Terms and Conditions
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThreeDPrinterUnit;
